module.exports = __webpack_public_path__ + "3fafcaa4efa0d62af832e1a23725e3e9.pdf";